export const phoneRegExp = /(\d{2})(\d)(\d{4})(\d{4})$/

export const phoneStringReplace = '($1) $2$3-$4'

export const removePhoneRegExp = /[\s\\()-]/g

export const removePhoneStringReplace = ''
